<template>
	<div>
		<div class="setting-container">
			  <el-radio-group class="type-radio-group" v-model="dateType" size="mini" @change="changeDateType">
				<el-radio-button label="1">近7天</el-radio-button>
				<el-radio-button label="2">近30天</el-radio-button>
				<el-radio-button label="3">今年</el-radio-button>
			  </el-radio-group>
			  <el-date-picker
				v-model="timeRange"
				@change="getdata"
				size="mini"
				type="daterange"
				range-separator="至"
				start-placeholder="开始日期"
				end-placeholder="结束日期">
			  </el-date-picker>
		</div>
		<div>
			<!-- 表格 -->
			<el-table border stripe
			  :data="dataList"
			  style="width: 100%">
			  <el-table-column
			    type="index"
			    label="#"
			    width="100">
			  </el-table-column>
			  <el-table-column
			    prop="phone_number"
			    label="按钮名称"
			    width="180">
			  </el-table-column>
			  <el-table-column
			    prop="money"
			    label="按钮页面" >
			  </el-table-column>
			  <el-table-column
			    prop="yqr"
			    label="点击次数">
			  </el-table-column>
			  <el-table-column
			    prop="yqr_phone"
			    label="点击人数">
			  </el-table-column>
			</el-table>
		</div>
	</div>
</template>

<script>
	import moment from 'moment'
	export default {
		data() {
			return {
				dateType: '1',
				timeRange: [],
				dataList: []
			}
		},
		methods: {
			getdata() {
				var params = {
					start_time: this.timeRange[0] ? moment(this.timeRange[0]).format('YYYY-MM-DD') : "",
					end_time: this.timeRange[1] ? moment(this.timeRange[1]).format('YYYY-MM-DD') : ''
				}
			  this.$axios.get("operation/account-data",params).then(res => {
			    if (res.code == 1) {
			       console.log(res)
			    }
			  });
			},
			changeDateType(n) {
				var now = new Date()
				var start = new Date()
				if(n == '1') {
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
				}else if(n == '2') {
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
				}else{
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
				}
				this.timeRange = [start,now]
				this.getdata()
			},
		},
		mounted() {
			var now = new Date(),start = new Date()
			var start = start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
			this.timeRange = [start,now]
			this.getdata()
		}
	}
</script>

<style scoped lang="scss">
	.setting-container{
		padding: 20px 0 10px;
		border-bottom: 8px solid #DCDFE6;
		margin-bottom: 20px;
	}
	.type-radio-group{
		margin: 10px 0;
		.el-radio-button{
			margin-right: 12px;
			/deep/ .el-radio-button__inner{
				border-left: 1px solid #DCDFE6;
				border-radius: 4px;
			}
			/deep/ .el-radio-button__orig-radio:checked+.el-radio-button__inner{
				border-left: 1px solid #409EFF;
			}
		}
	}
	.stastic-line{
		padding-bottom: 20px;
		border-bottom: 8px solid #DCDFE6;
		.el-col{
			text-align: center;
			h5{
				font-size: 24px;
				margin: 24px 0 2px;
			}
			p{
				font-size: 14px;
				color: rgb(102,102,102);
			}
			.icon-img{
				width: 12px;
				height: 12px;
				margin-left: 6px;
			}
		}
		
	}
</style>